import React from "react";
import { MapPin, Clock, Mail, Facebook, Instagram } from "lucide-react";
import { VENUE } from "../lib/venue";

export const Footer = () => {
  return (
    <footer
      id="visit"
      data-testid="footer-section"
      className="relative bg-black border-t border-white/10 pt-20 pb-10 px-6 sm:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12 pb-12 border-b border-white/10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img
                src={VENUE.logoUrl}
                alt="The Bar Colac — Colac live music and karaoke venue"
                className="h-14 w-14 object-contain"
              />
              <span className="font-display text-3xl uppercase tracking-wider text-[#FDFBF7]">
                The Bar
              </span>
            </div>
            <p className="text-[#FDFBF7]/65 max-w-md leading-relaxed">
              Colac's home of live entertainment every weekend — karaoke
              nights, live music and the best-feeling nights in town. Great
              drinks, great times, great people.
            </p>
            <div className="flex gap-3 mt-6">
              <a
                href={VENUE.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-white/15 hover:border-[#F5A623] hover:bg-[#F5A623] hover:text-black flex items-center justify-center text-[#FDFBF7] transition-colors"
              >
                <Facebook size={18} />
              </a>
              <a
                href={VENUE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-white/15 hover:border-[#F5A623] hover:bg-[#F5A623] hover:text-black flex items-center justify-center text-[#FDFBF7] transition-colors"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-xl uppercase text-[#F5A623] mb-5">
              Visit
            </h4>
            <ul className="space-y-4 text-[#FDFBF7]/75">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#F5A623] mt-0.5 shrink-0" />
                <span data-testid="footer-address">{VENUE.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-[#F5A623] mt-0.5 shrink-0" />
                <span data-testid="footer-hours">{VENUE.hours}</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-xl uppercase text-[#F5A623] mb-5">
              Get In Touch
            </h4>
            <ul className="space-y-4 text-[#FDFBF7]/75">
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#F5A623] mt-0.5 shrink-0" />
                <a
                  href={`mailto:${VENUE.email}`}
                  data-testid="footer-email"
                  className="hover:text-[#F5A623] transition-colors break-all"
                >
                  {VENUE.email}
                </a>
              </li>
              <li>
                <a
                  href="/join"
                  data-testid="footer-mailing-list-link"
                  className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] font-semibold text-[#FDFBF7]/85 hover:text-[#F5A623] transition-colors mt-1"
                >
                  Join the mailing list →
                </a>
              </li>
              <li>
                <a
                  href="#hire"
                  data-testid="footer-hire-link"
                  className="inline-flex items-center mt-2 text-sm uppercase tracking-[0.2em] font-bold text-black bg-[#F5A623] hover:bg-amber-400 px-5 py-3 transition-colors"
                >
                  Book Private Hire
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[#FDFBF7]/40">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} The Bar — Colac
          </div>
          <div>Great Drinks · Great Times · Great People</div>
        </div>
      </div>
    </footer>
  );
};
